import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ProductDashboardLastReceivedModel } from "src/app/core/models/product-model/product-dashboard-model/product-dashboard-lastreceived.model";
import { PRODUCT_DASHBOARD_TRANSPORT_LASTRECEIVED_DEMO } from "./product-dashboard-transport-lastreceived-demo-data";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-dashboard-transport-lastreceived.component.html',
    selector: 'op-product-dashboard-transport-lastreceived'
})
export class ProductDashboardTransportLastReceivedComponent implements AfterViewInit {
    public lastReceivedInfo: ProductDashboardLastReceivedModel[];
    
    constructor(private changeDetection: ChangeDetectorRef) {
        
    }

    ngAfterViewInit(): void {
        this.loadData();
    }

    private loadData() {
        setTimeout(() => {
            this.lastReceivedInfo = PRODUCT_DASHBOARD_TRANSPORT_LASTRECEIVED_DEMO;
            this.changeDetection.detectChanges();
        }, 500);
    }
}